import React from "react";

import {
  ThisEntityLocked,
  ThisEntityUnlocked,
} from "@hl/shared-features/lib/features/gate/GateConditionsModalBody";
import { GatedEntity } from "@hl/shared-features/lib/features/gate/types";
import { createStyles, Flex, UnstyledButton, Text } from "@mantine/core";

type StyleProps = { isCodeGenMint: boolean };
const useStyles = createStyles((theme, { isCodeGenMint }: StyleProps) => ({
  gateStatus: {
    borderBottomLeftRadius: theme.radius.sm,
    borderBottomRightRadius: theme.radius.sm,
    ...(isCodeGenMint && {
      borderTopLeftRadius: theme.radius.sm,
      borderTopRightRadius: theme.radius.sm,
      marginTop: 16,
    }),
  },
}));

type CardGateStatusProps = {
  isLocked: boolean;
  onShowDetails: () => void;
  entity: GatedEntity;
  isCodeGenMint: boolean;
};
const CardGateStatus = ({
  isLocked,
  onShowDetails,
  entity,
  isCodeGenMint,
}: CardGateStatusProps) => {
  const { classes } = useStyles({ isCodeGenMint });
  return (
    <Flex
      bg="gray.1"
      h={48}
      align="center"
      justify="space-between"
      px="sm"
      className={classes.gateStatus}
    >
      {isLocked ? (
        <ThisEntityLocked entity={entity} />
      ) : (
        <>
          <ThisEntityUnlocked entity={entity} />
          <UnstyledButton onClick={onShowDetails}>
            <Text>Details</Text>
          </UnstyledButton>
        </>
      )}
    </Flex>
  );
};

export default CardGateStatus;
